import { useMemo } from 'react';
import { mathFormat, newMathFormat, hanPullOffTime } from '@/pages/intelligence/utils/commonUtils';
import { hasMarketImgTooltip } from './_util';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import { moveZero } from '@/pages/intelligence/components/Chart/_config/topchartsChartUtils';
import ChartBubble from "@/pages/intelligence/components/ChartBubble";
import FacebookGamingIcon from '@/pages/intelligence/assets/svg/dataSource/fbgaming.svg';
import TwitchIcon from '@/pages/intelligence/assets/svg/dataSource/twitch.svg';
import YouTubeIcon from '@/pages/intelligence/assets/svg/dataSource/youtube.svg';
import { handleSerieSymbolConfig } from '@/pages/intelligence/utils/echartsUtils';

export default function _useLineCharts(props: any) {
  const {
    lineSeries, // 图例
    titleNow = '',
    setChartLoading,
    linexAxis,
    topChartsType,
    imageType,
    chartType,
  } = props;

  // console.log('_useLineCharts',props);

  // 默认浮窗内容
  const lineFormatterTooltip = (params: any[]) => {
    const paramsTemp = moveZero(params);
    return ChartBubble({
      data: paramsTemp,
      titleNow,
      topChartsType,
      imageType,
      chartType,
    });
  };

  const lineOption = useMemo(() => {
    const options = {
      aria: {},
      color: ECHARTSCOLOR,
      tooltip: {
        // confine: true,//fix遮挡:让tooltip展示在折线区域内
        borderWidth: 0,
        trigger: 'axis',
        padding: 0,
        formatter: lineFormatterTooltip,
        backgroundColor: 'rgba(0,0,0,0)'
      },
      grid: {
        bottom: "24px",
        containLabel: true,
        left: "10px",
        right: "30px",
        top: "20px",
      },
      legend: {
        show: true,
        type: 'scroll',
        orient: 'horizontal', // 横向
        pageIconColor: '#000', // 翻页箭头颜色
        selectedMode: true,
        pageIconSize: 13,
        pageTextStyle: {
          color: '#000', // 翻页数字颜色
        }, // 翻页数字设置
        icon: "circle",
        itemWidth: 8,
        itemHeight: 8,
        bottom: -6,
        left: 'center',
        formatter: (name: string) => {
          if (name === 'Twitch') {
            return `{twitchImg|} ${name}`;
          } if (name === 'Youtube') {
            return `{ytgImg| } ${name}`;
          } if (name === 'Facebook') {
            return `{facebookImg| } ${name}`;
          }
          return name;

        },
        textStyle: {
          color: '#888888',
          fontSize: 12,
          rich: {
            /** 圆点+图片，在 formatter里设置*/
            twitchImg: {
              height: 16,
              width: 16,
              backgroundColor: {
                image: TwitchIcon
              },
            },
            ytgImg: {
              height: 18,
              width: 18,
              backgroundColor: {
                image: YouTubeIcon
              },
            },
            facebookImg: {
              height: 18,
              width: 18,
              backgroundColor: {
                image: FacebookGamingIcon
              },
            },
          }
        }
      },
      xAxis: [{
        type: 'category',
        boundaryGap: true,
        data: linexAxis,
        axisTick: {
          alignWithLabel: true, // x轴刻度线与标签对齐
          lineStyle: {
            color: '#BFBFBF',
            width: 1,
          }
        },
        axisLabel: {
          color: '#000',
          align: 'center',
          opacity: 0.45,
          fontSize: 12,
          margin: 10,
        },
        axisLine: {
          show: true,
          onZero: false,// 当y轴有负数时,让x轴下落在y轴最小值
          lineStyle: {
            color: '#BFBFBF',
            width: 1,
          }
        }
      }],
      yAxis: [
        {
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          splitNumber: 4,
          axisLabel: {
            formatter(value: any) {
              return mathFormat(value, true);
            },
            color: '#000',
            opacity: 0.45,
            fontSize: 12,
          },
        },
      ],
      // series: lineSeries,
      series: handleSerieSymbolConfig(lineSeries),
    };
    setChartLoading && setChartLoading(false);
    return options;
  }, [props]);

  // console.log('lineOption', lineOption);

  return {
    lineOption,
  };
}
